<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header-pt.png')" class="page__header" />
      <div class="page__container">
        <table class="full-width mt-0">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVIÇOS INCLUÍDOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1"></th>
          </tr>
          <tr>
            <td class="body-2">Recolha e entrega no domicílio</td>
            <td class="body-2 text-center">Incluído</td>
          </tr>
          <tr class="mb-0 mt-0 pb-0 pt-0">
            <td class="body-2">
              Proteção base 10€/kg.
            </td>
            <td class="body-2 text-center">Incluído</td>
          </tr>   
        </table>

        <table class="full-width table-highlight body-2">
          <tr class="mb-0">
            <td class="no-margins">
              <strong>SERVIÇOS INCLUÍDOS APENAS NA OFERTA B2C</strong>
            </td>
          </tr>
          <tr class="mb-0 mt-0 pb-0 pt-0">
            <td class="body-2">
              1 Tentativa de Entrega + Avisado a Ponto Collectt
            </td>
            <td class="body-2 text-center">Incluído</td>
          </tr>
          <tr class="mb-0 mt-0 pb-0 pt-0">
            <td class="body-2">
              1 Tentativa de Entrega + Devolução
            </td>
            <td class="body-2 text-center">Incluído</td>
          </tr>
        </table>

        <table class="full-width table-highlight body-2">
          <tr class="mb-0">
            <td class="no-margins">
              <strong>NOTIFICAÇÕES</strong>
            </td>
          </tr>
          <tr class="no-margins my-0">
            <td class="no-margins">
              <ul>
                <li>
                  Os envios e24h (Para Amanhã) e e48h (Em Dois Dias) têm disponíveis:
                  <ul>
                    <li>
                      <strong>Previsão de entrega:</strong> enviamos a previsão de entrega ao destinatário do período concreto
                      do dia em que a entrega da sua encomenda irá ocorrer.
                    </li>
                    <li>
                      <strong>OTP:</strong> notificação ao destinatário a informar o código PIN (4 dígitos) para o recetor indicar ao distribuidor no momento da entrega em Portugal.
                    </li>
                    <li>Notificações sms/email ao longo do percurso das encomendas.</li>
                  </ul>
                </li>
              </ul>
            </td>
            <td class="body-2 body-2--bold text-right no-margins">Incluído</td>
          </tr>          
        </table>

        <!-- BLOQUE: SERVIÇOS ADICIONAIS -->
        <table
          v-if="hasAny(['COB','BACK','DDA','FRAGIL','SE1000','SE2500','SE5000','SE7500','SE10000','SE12500'])"
          class="full-width mt-0 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background"> 
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVIÇOS ADICIONAIS - TRANSVERSAIS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td colspan="2" class="body-2">
              A disponibilidade de serviços adicionais difere com cada produto e destino. Verificar características associadas ao(s) mesmo(s).
            </td>
          </tr>
          <!-- COB -->
          <tr v-if="getAdditionalServiceById('COB') && getAdditionalServiceById('COB').value !== undefined">
            <td class="body-2">
              {{ $t('COBRANÇA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('COB').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('COB').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- BACK -->
          <tr v-if="getAdditionalServiceById('BACK') && getAdditionalServiceById('BACK').value !== undefined">
            <td class="body-2">
              {{ $t('BACK') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('BACK').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('BACK').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- DDA -->
          <tr v-if="getAdditionalServiceById('DDA') && getAdditionalServiceById('DDA').value !== undefined">
            <td class="body-2">
              {{ $t('DDA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('DDA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('DDA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- FRAGIL -->
          <tr v-if="getAdditionalServiceById('FRAGIL') && getAdditionalServiceById('FRAGIL').value !== undefined">
            <td class="body-2">
              {{ $t('FRAGIL') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('FRAGIL').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('FRAGIL').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- Seguros Proteção Extra -->
          <tr v-if="getAdditionalServiceById('SE1000') && getAdditionalServiceById('SE1000').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_1000') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE1000').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE1000').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('SE2500') && getAdditionalServiceById('SE2500').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_2500') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE2500').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE2500').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('SE5000') && getAdditionalServiceById('SE5000').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_5000') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE5000').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE5000').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('SE7500') && getAdditionalServiceById('SE7500').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_7500') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE7500').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE7500').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('SE10000') && getAdditionalServiceById('SE10000').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_10000') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE10000').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE10000').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('SE12500') && getAdditionalServiceById('SE12500').value !== undefined">
            <td class="body-2">
              {{ $t('SEGURO_EXTRA_ATE_12500') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SE12500').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SE12500').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <Footer :page="previousPages + 1" />
    </div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header-pt.png')" class="page__header" />
      <div class="page__container">
        <!-- BLOQUE: SERVIÇOS ADICIONAIS - B2B -->
        <table
          v-if="hasAny(['B2B.SMS','B2B.SABADO'])"
          class="full-width mt-0 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVIÇOS ADICIONAIS - B2B
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td colspan="2" class="body-2">
              A disponibilidade de serviços adicionais difere com cada produto e destino. Verificar características associadas ao(s) mesmo(s).
            </td>
          </tr>
          <!-- SMS -->
          <tr v-if="getAdditionalServiceById('B2B.SMS') && getAdditionalServiceById('B2B.SMS').value !== undefined">
            <td class="body-2">
              {{ $t('SMS_PT') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('B2B.SMS').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('B2B.SMS').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- SABADOB2B -->
          <tr v-if="getAdditionalServiceById('B2B.SABADO') && getAdditionalServiceById('B2B.SABADO').value !== undefined">
            <td class="body-2">
              {{ $t('SABADOB2B') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('B2B.SABADO').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('B2B.SABADO').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>

        <!-- BLOQUE: SERVIÇOS ADICIONAIS - B2C -->
        <table
          v-if="hasAny(['PONTOCTT','2TENTCTT','2TENTDEV','REC0810','REC1013','REC1316','REC1619','REC1922','CONJUNTA','MANHA','TARDE','NOITE','SABADO','ALTMANHA','ALTTARDE','ALTNOITE','ALTDATA','ALTDESTINO','ALTORIGEM','ALTPRAZO','ALTM2M_MMR','ALTM2P_MMR','ALTP2M_MMR','ALTP2P_MMR','ALTM2M_OTR','ALTM2P_OTR','ALTP2M_OTR','ALTP2P_OTR','ALT0810','ALT1013','ALT1316','ALT1619','ALT1922','ALTMOR_MR','ALTMOR_OR'])"
          class="full-width mt-4 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVIÇOS ADICIONAIS - B2C
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td colspan="2" class="body-2">
              A disponibilidade de serviços adicionais difere com cada produto e destino. Verificar características associadas ao(s) mesmo(s).
            </td>
          </tr>
          <!-- PONTOCTT -->
          <tr v-if="getAdditionalServiceById('PONTOCTT') && getAdditionalServiceById('PONTOCTT').value !== undefined">
            <td class="body-2">
              {{ $t('ENTREGA_PONTO_CTT') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('PONTOCTT').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('PONTOCTT').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- 2TENTCTT -->
          <tr v-if="getAdditionalServiceById('2TENTCTT') && getAdditionalServiceById('2TENTCTT').value !== undefined">
            <td class="body-2">
              {{ $t('2_TENTATIVA_AVISAR_A_LOJA_CTT') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('2TENTCTT').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('2TENTCTT').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- 2TENTDEV -->
          <tr v-if="getAdditionalServiceById('2TENTDEV') && getAdditionalServiceById('2TENTDEV').value !== undefined">
            <td class="body-2">
              {{ $t('2_TENTATIVA_DEVOLVER') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('2TENTDEV').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('2TENTDEV').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- REC0810 -->
          <tr v-if="getAdditionalServiceById('REC0810') && getAdditionalServiceById('REC0810').value !== undefined">
            <td class="body-2">
              {{ $t('JANELA_RECOLHA_8_10') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('REC0810').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('REC0810').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- REC1013 -->
          <tr v-if="getAdditionalServiceById('REC1013') && getAdditionalServiceById('REC1013').value !== undefined">
            <td class="body-2">
              {{ $t('JANELA_RECOLHA_10_13') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('REC1013').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('REC1013').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- REC1316 -->
          <tr v-if="getAdditionalServiceById('REC1316') && getAdditionalServiceById('REC1316').value !== undefined">
            <td class="body-2">
              {{ $t('JANELA_RECOLHA_13_16') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('REC1316').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('REC1316').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- REC1619 -->
          <tr v-if="getAdditionalServiceById('REC1619') && getAdditionalServiceById('REC1619').value !== undefined">
            <td class="body-2">
              {{ $t('JANELA_RECOLHA_16_19') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('REC1619').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('REC1619').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- Nuevo: REC1922 -->
          <tr v-if="getAdditionalServiceById('REC1922') && getAdditionalServiceById('REC1922').value !== undefined">
            <td class="body-2">
              {{ $t('JANELA_RECOLHA_19_22') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('REC1922').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('REC1922').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- CONJUNTA -->
          <tr v-if="getAdditionalServiceById('CONJUNTA') && getAdditionalServiceById('CONJUNTA').value !== undefined">
            <td class="body-2">
              {{ $t('ENTREGA_CONJUNTA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('CONJUNTA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('CONJUNTA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- MANHA -->
          <tr v-if="getAdditionalServiceById('MANHA') && getAdditionalServiceById('MANHA').value !== undefined">
            <td class="body-2">
              {{ $t('MANHA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('MANHA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('MANHA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TARDE -->
          <tr v-if="getAdditionalServiceById('TARDE') && getAdditionalServiceById('TARDE').value !== undefined">
            <td class="body-2">
              {{ $t('TARDE') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TARDE').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TARDE').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- NOITE -->
          <tr v-if="getAdditionalServiceById('NOITE') && getAdditionalServiceById('NOITE').value !== undefined">
            <td class="body-2">
              {{ $t('NOITE') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('NOITE').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('NOITE').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- SABADO -->
          <tr v-if="getAdditionalServiceById('SABADO') && getAdditionalServiceById('SABADO').value !== undefined">
            <td class="body-2">
              {{ $t('SABADO') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('SABADO').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('SABADO').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTMANHA -->
          <tr v-if="getAdditionalServiceById('ALTMANHA') && getAdditionalServiceById('ALTMANHA').value !== undefined">
            <td class="body-2">
              {{ $t('ALTMANHA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTMANHA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTMANHA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTTARDE -->
          <tr v-if="getAdditionalServiceById('ALTTARDE') && getAdditionalServiceById('ALTTARDE').value !== undefined">
            <td class="body-2">
              {{ $t('ALTTARDE') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTTARDE').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTTARDE').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTNOITE -->
          <tr v-if="getAdditionalServiceById('ALTNOITE') && getAdditionalServiceById('ALTNOITE').value !== undefined">
            <td class="body-2">
              {{ $t('ALTNOITE') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTNOITE').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTNOITE').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTDATA (Alteração Data de Entrega) -->
          <tr v-if="getAdditionalServiceById('ALTDATA') && getAdditionalServiceById('ALTDATA').value !== undefined">
            <td class="body-2">
              {{ $t('ALTDATA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTDATA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTDATA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTDESTINO -->
          <tr v-if="getAdditionalServiceById('ALTDESTINO') && getAdditionalServiceById('ALTDESTINO').value !== undefined">
            <td class="body-2">
              {{ $t('ALTDESTINO') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTDESTINO').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTDESTINO').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTORIGEM -->
          <tr v-if="getAdditionalServiceById('ALTORIGEM') && getAdditionalServiceById('ALTORIGEM').value !== undefined">
            <td class="body-2">
              {{ $t('ALTORIGEM') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTORIGEM').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTORIGEM').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTPRAZO -->
          <tr v-if="getAdditionalServiceById('ALTPRAZO') && getAdditionalServiceById('ALTPRAZO').value !== undefined">
            <td class="body-2">
              {{ $t('ALTPRAZO') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTPRAZO').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTPRAZO').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTM2M_MMR -->
          <tr v-if="getAdditionalServiceById('ALTM2M_MMR') && getAdditionalServiceById('ALTM2M_MMR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTM2M_MMR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTM2M_MMR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTM2M_MMR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTM2P_MMR -->
          <tr v-if="getAdditionalServiceById('ALTM2P_MMR') && getAdditionalServiceById('ALTM2P_MMR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTM2P_MMR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTM2P_MMR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTM2P_MMR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTP2M_MMR -->
          <tr v-if="getAdditionalServiceById('ALTP2M_MMR') && getAdditionalServiceById('ALTP2M_MMR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTP2M_MMR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTP2M_MMR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTP2M_MMR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTP2P_MMR -->
          <tr v-if="getAdditionalServiceById('ALTP2P_MMR') && getAdditionalServiceById('ALTP2P_MMR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTP2P_MMR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTP2P_MMR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTP2P_MMR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTM2M_OTR -->
          <tr v-if="getAdditionalServiceById('ALTM2M_OTR') && getAdditionalServiceById('ALTM2M_OTR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTM2M_OTR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTM2M_OTR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTM2M_OTR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTM2P_OTR -->
          <tr v-if="getAdditionalServiceById('ALTM2P_OTR') && getAdditionalServiceById('ALTM2P_OTR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTM2P_OTR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTM2P_OTR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTM2P_OTR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTP2M_OTR -->
          <tr v-if="getAdditionalServiceById('ALTP2M_OTR') && getAdditionalServiceById('ALTP2M_OTR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTP2M_OTR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTP2M_OTR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTP2M_OTR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTP2P_OTR -->
          <tr v-if="getAdditionalServiceById('ALTP2P_OTR') && getAdditionalServiceById('ALTP2P_OTR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTP2P_OTR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTP2P_OTR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTP2P_OTR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALT0810 -->
          <tr v-if="getAdditionalServiceById('ALT0810') && getAdditionalServiceById('ALT0810').value !== undefined">
            <td class="body-2">
              {{ $t('ALT0810') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALT0810').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALT0810').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALT1013 -->
          <tr v-if="getAdditionalServiceById('ALT1013') && getAdditionalServiceById('ALT1013').value !== undefined">
            <td class="body-2">
              {{ $t('ALT1013') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALT1013').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALT1013').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALT1316 -->
          <tr v-if="getAdditionalServiceById('ALT1316') && getAdditionalServiceById('ALT1316').value !== undefined">
            <td class="body-2">
              {{ $t('ALT1316') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALT1316').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALT1316').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALT1619 -->
          <tr v-if="getAdditionalServiceById('ALT1619') && getAdditionalServiceById('ALT1619').value !== undefined">
            <td class="body-2">
              {{ $t('ALT1619') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALT1619').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALT1619').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALT1922 -->
          <tr v-if="getAdditionalServiceById('ALT1922') && getAdditionalServiceById('ALT1922').value !== undefined">
            <td class="body-2">
              {{ $t('ALT1922') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALT1922').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALT1922').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTMOR_MR -->
          <tr v-if="getAdditionalServiceById('ALTMOR_MR') && getAdditionalServiceById('ALTMOR_MR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTMOR_MR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTMOR_MR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTMOR_MR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- ALTMOR_OR -->
          <tr v-if="getAdditionalServiceById('ALTMOR_OR') && getAdditionalServiceById('ALTMOR_OR').value !== undefined">
            <td class="body-2">
              {{ $t('ALTMOR_OR') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('ALTMOR_OR').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('ALTMOR_OR').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>

        <!-- BLOQUE: SERVIÇOS ADICIONAIS - CARGA -->
        <table
          v-if="hasAny(['CARGA.COB','CARGA.DDA','CARGA.FRAGIL','CARGA.SEGURO'])"
          class="full-width mt-4 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVIÇOS ADICIONAIS - CARGA
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td colspan="2" class="body-2">
              A disponibilidade de serviços adicionais difere com cada produto e destino. Verificar características associadas ao(s) mesmo(s).
            </td>
          </tr>
          <!-- CARGA.COB -->
          <tr v-if="getAdditionalServiceById('CARGA.COB') && getAdditionalServiceById('CARGA.COB').value !== undefined">
            <td class="body-2">
              {{ $t('COBRANCA_CARGA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('CARGA.COB').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('CARGA.COB').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- CARGA.DDA -->
          <tr v-if="getAdditionalServiceById('CARGA.DDA') && getAdditionalServiceById('CARGA.DDA').value !== undefined">
            <td class="body-2">
              {{ $t('DDA_CARGA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('CARGA.DDA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('CARGA.DDA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <Footer :page="previousPages + 2" />
    </div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header-pt.png')" class="page__header" />
      <div class="page__container">
        <!-- BLOQUE: TAXAS (YA EXISTENTE) -->
        <table
          v-if="hasAny(['TXENRGDISC','TXRECNEFECT','TXDISFORME','TXDISFORMEDEV','TXDUA','TXREMESSA9+','TXCEP.ENRGDISC','TXCEP.RECNEFECT','TXCEP.DISFORME','TXCEP.DUA','TXCEP.REMESSA9+'])"
          class="full-width mt-0 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              TAXAS - B2C/B2B
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>

          <tr v-if="getAdditionalServiceById('TXENRGDISC') && getAdditionalServiceById('TXENRGDISC').value !== undefined">
            <td class="body-2">
              {{ $t('TXENRGDISC') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXENRGDISC').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXENRGDISC').value }}
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('TXRECNEFECT') && getAdditionalServiceById('TXRECNEFECT').value !== undefined">
            <td class="body-2">
              {{ $t('TXRECNEFECT') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXRECNEFECT').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXRECNEFECT').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('TXDISFORME') && getAdditionalServiceById('TXDISFORME').value !== undefined">
            <td class="body-2">
              {{ $t('TXDISFORME') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXDISFORME').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXDISFORME').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('TXDISFORMEDEV') && getAdditionalServiceById('TXDISFORMEDEV').value !== undefined">
            <td class="body-2">
              {{ $t('TXDISFORMEDEV') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXDISFORMEDEV').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXDISFORMEDEV').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('TXDUA') && getAdditionalServiceById('TXDUA').value !== undefined">
            <td class="body-2">
              {{ $t('TXDUA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXDUA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXDUA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <tr v-if="getAdditionalServiceById('TXREMESSA9+') && getAdditionalServiceById('TXREMESSA9+').value !== undefined">
            <td class="body-2">
              {{ $t('TXREMESSA9+') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXREMESSA9+').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXREMESSA9+').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.ENRGDISC -->
          <tr v-if="getAdditionalServiceById('TXCEP.ENRGDISC') && getAdditionalServiceById('TXCEP.ENRGDISC').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_COMBUSTIVEL') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCEP.ENRGDISC').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCEP.ENRGDISC').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.RECNEFECT -->
          <tr v-if="getAdditionalServiceById('TXCEP.RECNEFECT') && getAdditionalServiceById('TXCEP.RECNEFECT').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_RECOLHA_NAO_EFETUADA') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCEP.RECNEFECT').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCEP.RECNEFECT').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.DISFORME -->
          <tr v-if="getAdditionalServiceById('TXCEP.DISFORME') && getAdditionalServiceById('TXCEP.DISFORME').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_DISFORME') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCEP.DISFORME').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCEP.DISFORME').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.DUA -->
          <tr v-if="getAdditionalServiceById('TXCEP.DUA') && getAdditionalServiceById('TXCEP.DUA').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_DESPACHO_UNICO_ADUANEIRO') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCEP.DUA').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCEP.DUA').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.REMESSA9+ -->
          <tr v-if="getAdditionalServiceById('TXCEP.REMESSA9+') && getAdditionalServiceById('TXCEP.REMESSA9+').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_REMESSA_9+') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCEP.REMESSA9+').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCEP.REMESSA9+').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>

        <!-- BLOQUE: TAXAS CARGA -->
        <table
          v-if="hasAny(['TXCARGA.ENRGDISC','TXCARGA.DISFORME','TXCARGA.VOLNCINT','TXCARGA.MD3','TXCARGA.GRANDESUP'])"
          class="full-width mt-4 additional-services-table"
        >
          <colgroup>
            <col style="width: 75%" />
            <col style="width: 25%" />
          </colgroup>
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              TAXAS - CARGA
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>

          <!-- TXCEP.ENRGDISC para CARGA -->
          <tr v-if="getAdditionalServiceById('TXCARGA.ENRGDISC') && getAdditionalServiceById('TXCARGA.ENRGDISC').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_COMBUSTIVEL') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCARGA.ENRGDISC').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCARGA.ENRGDISC').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCEP.DISFORME para CARGA -->
          <tr v-if="getAdditionalServiceById('TXCARGA.DISFORME') && getAdditionalServiceById('TXCARGA.DISFORME').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_DISFORME') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCARGA.DISFORME').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCARGA.DISFORME').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCARGA.VOLNCINT -->
          <tr v-if="getAdditionalServiceById('TXCARGA.VOLNCINT') && getAdditionalServiceById('TXCARGA.VOLNCINT').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_CARGA_VOLUME') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCARGA.VOLNCINT').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCARGA.VOLNCINT').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCARGA.MD3 -->
          <tr v-if="getAdditionalServiceById('TXCARGA.MD3') && getAdditionalServiceById('TXCARGA.MD3').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_CARGA_MD3') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCARGA.MD3').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCARGA.MD3').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>

          <!-- TXCARGA.GRANDESUP -->
          <tr v-if="getAdditionalServiceById('TXCARGA.GRANDESUP') && getAdditionalServiceById('TXCARGA.GRANDESUP').value !== undefined">
            <td class="body-2">
              {{ $t('TAXA_CARGA_ENTREGA_GRANDES_SUPERFICIES') }}
            </td>
            <td nowrap class="body-2 text-center">
              <template v-if="Number(getAdditionalServiceById('TXCARGA.GRANDESUP').value) === 0">
                {{ $t('NOT_INCLUDED_PT') }}
              </template>
              <template v-else>
                {{ getAdditionalServiceById('TXCARGA.GRANDESUP').value }}<span class="euro-symbol">€</span>
              </template>
            </td>
          </tr>
        </table>

      </div>
      <Footer :page="previousPages + 3" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/Footer'

export default {
  name: 'AdditionalServices',
  components: { Footer },
  data() {
    return {
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    hasAny(ids) {
      if (!Array.isArray(ids) || ids.length === 0) return false
      return ids.some(id => {
        const svc = this.getAdditionalServiceById(id)
        return svc && svc.value !== undefined
      })
    },
  },
  computed: {
    previousPages() {
      return this.$parent.sectionPreviousPages('AdditionalServices')
    }
  },
}
</script>

<style>
.additional-services-table td {
  vertical-align: top;
}

.additional-services-table td:nth-child(2) {
  text-align: center !important;
  padding-right: 8px !important;
}

.no-margins {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
